import React from 'react';
import Icon from '../../../components/AppIcon';

const ResultInterpretationPanel = ({ interpretation }) => {
  if (!interpretation) {
    return (
      <div className="bg-card rounded-lg border border-border p-6 md:p-8 text-center">
        <Icon name="FileSearch" size={48} className="mx-auto mb-4 text-muted-foreground" />
        <p className="text-sm md:text-base text-muted-foreground">
          Select a lab result to view clinical interpretation
        </p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 space-y-4 md:space-y-6">
      <div>
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2">
          Clinical Interpretation
        </h3>
        <p className="text-sm md:text-base text-muted-foreground">{interpretation?.testName}</p>
      </div>
      <div className="space-y-4">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Info" size={18} color="var(--color-primary)" />
            <h4 className="text-sm md:text-base font-semibold text-foreground">Clinical Significance</h4>
          </div>
          <p className="text-sm md:text-base text-foreground pl-7">{interpretation?.significance}</p>
        </div>

        {interpretation?.possibleCauses && (
          <div>
            <div className="flex items-center gap-2 mb-2">
              <Icon name="AlertTriangle" size={18} color="var(--color-warning)" />
              <h4 className="text-sm md:text-base font-semibold text-foreground">Possible Causes</h4>
            </div>
            <ul className="space-y-1 pl-7">
              {interpretation?.possibleCauses?.map((cause, index) => (
                <li key={index} className="text-sm md:text-base text-foreground">
                  • {cause}
                </li>
              ))}
            </ul>
          </div>
        )}

        {interpretation?.recommendedActions && (
          <div>
            <div className="flex items-center gap-2 mb-2">
              <Icon name="ClipboardCheck" size={18} color="var(--color-success)" />
              <h4 className="text-sm md:text-base font-semibold text-foreground">Recommended Actions</h4>
            </div>
            <ul className="space-y-1 pl-7">
              {interpretation?.recommendedActions?.map((action, index) => (
                <li key={index} className="text-sm md:text-base text-foreground">
                  • {action}
                </li>
              ))}
            </ul>
          </div>
        )}

        {interpretation?.clinicalGuidelines && (
          <div className="bg-muted rounded-lg p-3 md:p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="BookOpen" size={18} color="var(--color-secondary)" />
              <h4 className="text-sm md:text-base font-semibold text-foreground">Clinical Guidelines</h4>
            </div>
            <p className="text-xs md:text-sm text-muted-foreground pl-7">
              {interpretation?.clinicalGuidelines}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResultInterpretationPanel;